import { render, staticRenderFns } from "./basic-tables.vue?vue&type=template&id=68e6c0fc&"
import script from "./basic-tables.vue?vue&type=script&lang=js&"
export * from "./basic-tables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports